import { Configuration, PopupRequest } from "@azure/msal-browser";

const clientId = import.meta.env.VITE_AZURE_CLIENT_ID as string;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    // common = multi-tenant + personal Microsoft accounts
    authority: "https://login.microsoftonline.com/common",
    // Office add-ins cannot use redirects; loginPopup is required.
    redirectUri: window.location.origin,
  },
  cache: {
    // localStorage is shared between the parent window and the popup window.
    // sessionStorage is NOT reliably shared, which causes no_token_request_cache_error.
    cacheLocation: "localStorage",
  },
};

/**
 * Standard OIDC scopes — no "Expose an API" configuration needed in Azure.
 * The resulting ID token (result.idToken) is sent to the Laravel backend.
 * The ID token's aud claim equals the clientId GUID, which the backend validates.
 */
export const loginRequest: PopupRequest = {
  scopes: ["openid", "profile", "email"],
  // Dedicated blank page so the popup doesn't load the full add-in before MSAL can process the auth code.
  redirectUri: `${window.location.origin}/auth-redirect.html`,
};
